// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"450":"0be0328884fdd4f5","4775":"1553bdd333939a69","5941":"38ec1a2078a9bf65","6028":"e1006fb68d9549eb"}[chunkId] + ".css";
};